import { ReactNode } from 'react'

interface ListRecordLayoutProps {
	listPanel: ReactNode
	recordPanel: ReactNode
}

export function ListRecordLayout({ listPanel, recordPanel }: ListRecordLayoutProps) {
	return (
		<div className="flex h-full w-full">
			<div className="flex-1">
				{listPanel}
			</div>
			{recordPanel}
		</div>
	)
}
